import script from "./PassCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PassCard.vue?vue&type=script&setup=true&lang=ts"

import "./PassCard.vue?vue&type=style&index=0&id=61d3be57&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d3be57"]])

export default __exports__